import React, { useEffect, useState } from 'react'
import { createChartsProps, donutType } from '../../../../../../../Assests/DashboardUtility'
import { appointmentReportSummaryDataPie } from '../../../../../../../Assests/GraphUtilities'
import _ from 'lodash'
import { AppConstant } from '../../../../../../../Assests/AppConstant'
import { smartScheduleSelector } from '../../../../../../../../redux/reducers/reducerSlices/SmartScheduleReducer'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { getUserSelector } from '../../../../../../../../redux/reducers/reducerSlices/UserReducer'
import { sagaActions } from '../../../../../../../../sagas/sagaActions'
import { getAuthReducer } from '../../../../../../../../redux/reducers/reducerSlices/AuthReducer'
import { displayLoader, formatDate_MM_DD_YYYY, shouldHavePermission } from '../../../../../../../Assests/Utility'
import './AllAppointmentsListSS.css'
import AppointmentReportSummaryGraphical from './Components/AppointmentReportSummaryGraphical'
import AppointmentReportSummarySubHeader from './Components/AppointmentReportSummarySubHeader'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import { getLocalDateString } from '../../../../../../../../Utils/DateUtils'
import WarehouseFiltersForReports from './Components/WarehouseFiltersForReports'
import CustomDropDown from '../../../../../../Common/CustomDropDown/CustomDropDown'

/**
 * Component for appointment summary
 * @param {*} props 
 * @returns 
 */
const AppointmentReportSummary = (props) => {
    const { themeSelected = 'light-mode' } = props;
    const ss = useSelector(smartScheduleSelector);
    const { appointmentReportSummary, initateLoading, startDate, endDate } = ss;
    const userPermission = useSelector(getUserSelector);
    const { selectedWarehouse, permissions } = userPermission;
    const dispatch = useDispatch()
    const [appointmentReportSummaryData, setAppointmentReportSummaryData] = useState(null)
    const [selectedStartDate, setSelectedStartDate] = useState(null)
    const [selectedEndDate, setSelectedEndDate] = useState(null)
    const [allowPermission, setAllowPermission] = useState(false)
    const [currentWarehouseFilterSelected, setCurrentWarehouseFilterSelected] = useState(null)
    const [dateRangeMode, setDateRangeMode] = useState('last30'); // 'last30' | 'last60' | 'custom'
    const navigate = useNavigate();
    const [downloadWarehouseFilterSelected, setDownloadWarehouseFilterSelected] = useState(null);

    /**
     * useEffect to call get appointment summary data function on load
     * Defaults to last 30 days
     */
    useEffect(() => {
        const today = new Date();
        const start = new Date();
        start.setDate(start.getDate() - 30);
        setSelectedStartDate(start);
        setSelectedEndDate(today);
    }, [])

    // Update dates when dateRangeMode changes
    useEffect(() => {
        if (dateRangeMode === 'last30') {
            const today = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 30);
            setSelectedStartDate(start);
            setSelectedEndDate(today);
        } else if (dateRangeMode === 'last60') {
            const today = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 60);
            setSelectedStartDate(start);
            setSelectedEndDate(today);
        } else if (dateRangeMode === 'custom') {
            // Default to next 7 days when choosing custom date range
            const today = new Date();
            const end = new Date();
            end.setDate(end.getDate() + 7);
            setSelectedStartDate(today);
            setSelectedEndDate(end);
        }
    }, [dateRangeMode])

    /**
     * useEffect to check warehouse management permission
     */
    useEffect(() => {
        if (permissions && permissions.length) {
            const warehouseManagementPermission = _.find(permissions, { 'FeatureID': '12', 'PageAccess': true });
            if (warehouseManagementPermission && !_.isEmpty(warehouseManagementPermission)) {
                let temp = shouldHavePermission(permissions, '1000');
                setAllowPermission(temp);
                console.log("🚀 ~ AppointmentReportSummary ~ temp:", temp)
                if (temp) {
                    if (selectedWarehouse) {
                        const warehouseName = selectedWarehouse.ExternalSiteID
                            ? `${selectedWarehouse.ExternalSiteID} - ${selectedWarehouse.Name}`
                            : selectedWarehouse.Name;
                        setCurrentWarehouseFilterSelected({ ID: selectedWarehouse.ID, name: warehouseName })
                    }
                    else {
                        setCurrentWarehouseFilterSelected({ ID: null, name: 'All Warehouse' })
                    }
                }
            }
        }
    }, [permissions]);

    /**
     * useEffect to set start date in redux
     */
    useEffect(() => {
        dispatch({ type: sagaActions.UPDATE_START_DATE, payload: new Date(selectedStartDate) })
        const getstartDate = () => {
            let d = new Date()
            d.setDate(d.getDate() - 7)
            return d
        }
        return (() => dispatch({ type: sagaActions.UPDATE_START_DATE, payload: getstartDate() }))
    }, [selectedStartDate])

    /**
     * useEffect to set end date in redux
     */
    useEffect(() => {
        dispatch({ type: sagaActions.UPDATE_END_DATE, payload: new Date(selectedEndDate) })
        return (() => dispatch({ type: sagaActions.UPDATE_END_DATE, payload: new Date() }))
    }, [selectedEndDate])

    useEffect(() => {
        if (selectedStartDate && selectedEndDate) {
            setTimeout(() => {
                getApptSummary()
            }, [0])
        }
    }, [selectedStartDate, selectedEndDate, currentWarehouseFilterSelected])

    /**
     * Function to fetch graph data for appointment summary
     */
    const getApptSummary = () => {
        const payload = {
            "WHID": allowPermission ? (currentWarehouseFilterSelected?.ID || null) : selectedWarehouse.ID,
            "Type": "graphical",
            "startDate": selectedStartDate ? getLocalDateString(selectedStartDate) : null,
            "endDate": selectedEndDate ? getLocalDateString(selectedEndDate) : null,
            "CompanyID": allowPermission ? (currentWarehouseFilterSelected?.ID ? null : selectedWarehouse.CompanyID) : null
        }
        dispatch({ type: sagaActions.APPOINTMENT_REPORT_SUMMARY, payload: payload })

    }




    /**
     * useEffect to form graph data
     */
    useEffect(() => {
        if (appointmentReportSummary) {

            createAppointmentReportSummary()
        }
    }, [appointmentReportSummary])

    /**
     * Function to form graph data
     */
    const createAppointmentReportSummary = () => {
        let summaryData = null;
        if (appointmentReportSummary) {
            summaryData = [
                {
                    name: "Warehouse",
                    data: appointmentReportSummary?.Warehouse
                },
                {
                    name: "Carrier",
                    data: appointmentReportSummary?.Carrier
                }
            ]
        }

        if (summaryData && !_.isEmpty(summaryData)) {
            const dataDonutArray = AppConstant.appointmentReportSummary.labels
            const datadonut = dataDonutArray.map(el => {
                const filterIfdata = _.filter(summaryData, { name: el })
                if (_.size(filterIfdata)) {
                    return filterIfdata[0].data
                } else {
                    return 0
                }
            })
            const apptReportSummarydonut = createChartsProps(datadonut, donutType.AppointmentReportSummary, themeSelected, appointmentReportSummaryDataPie)
            let setData = { ...props, apptReportSummarydonut };
            setData.themeSelected = themeSelected;
            setAppointmentReportSummaryData(setData);
        }
    }

    /**
     * Function to handle navigation for drilldown report
     * Passes selected warehouse as query params so drilldown can pre-populate
     */
    const getSubRoot = () => {
        const status = localStorage.getItem("appointmentReportSummary")
        const warehouseQuery = currentWarehouseFilterSelected
            ? `?whId=${currentWarehouseFilterSelected.ID ?? ''}&whName=${encodeURIComponent(currentWarehouseFilterSelected.name || 'All Warehouse')}`
            : '';
        if (status === "0") {
            navigate(`appointmentsummary/warehouse/${selectedStartDate}/${selectedEndDate}${warehouseQuery}`)
        } else if (status === "1") {
            navigate(`appointmentsummary/carrier/${selectedStartDate}/${selectedEndDate}${warehouseQuery}`)
        }
    }

    return (
        <div className='appointments-report-ss-wrapper p-3'>
            <div className='container-fluid createPo-wrapper-ss my-0 mx-3 appt-report-headers-full'>
                <h4>{AppConstant.appointmentReportSummary.header}</h4>
                {/* <div className='d-flex align-items-center flex-wrap' style={{ gap: '8px' }}> */}
                <div className='d-flex justify-content-end align-items-center all-appt-list-action-right'>
                    {/* Date Range Selector Dropdown */}
                    <div className='me-2'>
                        <CustomDropDown
                            themeSelected={themeSelected}
                            data={[
                                { id: 'last30', name: 'Last 30 Days' },
                                { id: 'last60', name: 'Last 60 Days' },
                                { id: 'custom', name: 'Choose Date' },
                            ]}
                            placeHolder={dateRangeMode === 'last30' ? 'Last 30 Days' : dateRangeMode === 'last60' ? 'Last 60 Days' : 'Choose Date'}
                            onSelect={(event) => setDateRangeMode(event.id)}
                            keyStr={'name'}
                            maxChars={15}
                        />
                    </div>
                    {/* Custom date pickers — only visible in 'custom' mode */}
                    {dateRangeMode === 'custom' && (
                        <AppointmentReportSummarySubHeader
                            getData={getApptSummary}
                            selectedStartDate={selectedStartDate}
                            setSelectedStartDate={setSelectedStartDate}
                            selectedEndDate={selectedEndDate}
                            setSelectedEndDate={setSelectedEndDate}
                            themeSelected={themeSelected}
                        />
                    )}
                    {/* Warehouse filter — always shown when permission allows */}
                    {allowPermission && (
                        <WarehouseFiltersForReports
                            currentWarehouseFilterSelected={currentWarehouseFilterSelected}
                            setCurrentWarehouseFilterSelected={setCurrentWarehouseFilterSelected}
                            themeSelected={themeSelected}
                        />
                    )}
                </div>
            <p className='text-danger mb-0 text-end' style={{ fontSize: 'small' }}>{AppConstant.appointmentReportSummary.dateFilterDisclaimer}</p>
            </div>
            <br />
            <br />
            <br />
            {!initateLoading ?
                <AppointmentReportSummaryGraphical appointmentReportSummaryData={appointmentReportSummaryData} getSubRoot={getSubRoot} />
                :
                <div className='w-100'>{displayLoader('light-mode', 50, 11)}</div>
            }
        </div>
    )
}

export default AppointmentReportSummary